import { useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToId } from "./SmoothScroll";

export const Footer = () => {
  const navigate = useNavigate();
  return (
  <footer className="relative overflow-hidden bg-[#071A2E] pt-20 text-white" data-testid="footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-12">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo dark />
          <p className="mt-6 max-w-sm text-base leading-relaxed text-slate-300">
            Specialising in delivering Aviation Solutions at the speed of capability needs.
          </p>
        </div>
        <div className="space-y-4 md:col-span-4">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-sky-300">Company</p>
          <p className="text-sm text-slate-300" data-testid="footer-abn-info">ABN 147 024 828 80</p>
          <p className="text-sm text-slate-300" data-testid="footer-acn-info">ACN 702 482 880</p>
          <p className="text-sm leading-relaxed text-slate-300" data-testid="footer-registered-office">
            Registered Office<br />Level 1, 63-67 Ann St<br />Surry Hills NSW 2010 Australia
          </p>
        </div>
        <div className="space-y-4 md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-sky-300">Contact</p>
          <a href="tel:+61481418199" className="block text-sm text-slate-300 transition-colors hover:text-white" data-testid="footer-phone">+61 481 418 199</a>
          <a href="mailto:sales@AeroSoftSolutions.com.au" className="block break-all text-sm text-slate-300 transition-colors hover:text-white" data-testid="footer-email">sales@AeroSoftSolutions.com.au</a>
          <button onClick={() => scrollToId("top")} className="text-sm text-sky-300 transition-colors hover:text-white" data-testid="footer-back-to-top">Back to top ↑</button>
        </div>
      </div>
      <p className="mt-20 select-none font-display text-[19vw] font-semibold leading-[0.8] tracking-[-0.06em] text-white/[0.06] md:text-[13vw]" aria-hidden="true">
        AeroSoft
      </p>
      <div className="flex flex-col gap-2 border-t border-white/10 py-6 text-xs text-slate-400 sm:flex-row sm:justify-between">
        <span><span onClick={() => navigate("/apps")} data-testid="footer-copyright-shortcut">©</span> {new Date().getFullYear()} Aero Soft Solutions Pty Ltd. All rights reserved.</span>
        <span>Surry Hills · Sydney · Australia</span>
      </div>
    </div>
  </footer>
  );
};
